export class Groups {
    public id: number;
    public name: string;
    public description: string;
    public added_by: number;
    public is_deleted: number;
}
